import { Badge, Pill } from '@design-system';
import Link from 'next/link';
import { FC } from 'react';

import { PLACE_HOLDER_IMAGE } from '../../constants';
import { Ratio } from '../../helpers/images';
import { Image } from '../Image';
import { PublishedAt, ReadingTime } from '../Posts';

interface JournalsCardProps {
  description: string | null;
  eagerLoading?: boolean;
  href: string;
  image: StoryblokImage | null;
  imageRatio?: Ratio;
  mediaDuration?: string;
  onClick: () => void;
  publishedAt: string | null;
  readingTime: number;
  tag?: string | null;
  title: string | null;
}

export const JournalsCard: FC<JournalsCardProps> = ({
  description,
  eagerLoading = false,
  href,
  image,
  imageRatio = '4/3',
  mediaDuration,
  onClick,
  publishedAt,
  readingTime,
  tag,
  title,
}) => (
  <Link
    className="group relative flex flex-col items-start gap-3 duration-300"
    href={href}
    onClick={onClick}
    prefetch={false}
  >
    <Image
      alt={image?.alt || PLACE_HOLDER_IMAGE}
      className="rounded-sm"
      eagerLoading={eagerLoading}
      focus={image?.focus}
      hoverEffect
      size={{
        sm: { ratio: imageRatio, span: 12 },
        md: { ratio: imageRatio, span: 4 },
        lg: { ratio: imageRatio, span: 3 },
      }}
      src={image?.filename || PLACE_HOLDER_IMAGE}
    />
    {mediaDuration && (
      <span className="absolute right-4 top-4">
        <Badge label={mediaDuration} />
      </span>
    )}
    {tag && <Pill label={tag} />}
    <div className="flex flex-col group-hover:text-neutral-4 md:transition-colors">
      <h3 className="text-md font-bold">{title}</h3>
      <p className="line-clamp-3">{description}</p>
    </div>
    <span className="w-full text-neutral-4">
      <PublishedAt date={publishedAt || ''} />
      <ReadingTime
        minutes={readingTime > 1 ? String(readingTime) : ''}
        separator
      />
    </span>
  </Link>
);
